import React from "react";
import { createRoot } from "react-dom/client";
import "@/lib/i18n";
import App from "@/App";
import "@/styles/index.css";

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
